<template>
  <div
    class="relative w-full lg:pb-8 max-w-screen-4xl bg-white mx-auto items-center justify-center px-4 lg:px-32"
  >
    <!-- Title -->
    <strong
      class="text-3xl block md:text-3xl lg:text-4xl self-start mb-4 pt-5 lg:text-left"
    >
      Featured Initiatives...</strong
    >
    <!-- First Initiative Section -->
    <div
      class="flex flex-col md:flex-row items-center justify-between px-4 py-6 gap-6"
    >
      <!-- Image -->
      <img
        src="../assets/images/pitch-your-dreambandwhite.jpg"
        class="w-30 h-30 md:w-60 md:h-50 object-cover rounded-md"
      />

      <!-- Text Section -->
      <div class="flex-1 md:px-6 text-center md:text-left gap-6">
        <strong class="text-2xl md:text-3xl block">
          Pitch Your Dream Enterprise Challenge
        </strong>
        <p class="mt-2">
          An Enterprise Challenge designed to help Nigerian Youths with the
          right Knowledge and Grants to fund their Innovative Ideas.
        </p>
      </div>

      <!-- Button -->
      <div class="mt-4 lg:pt-20 md:mt-0">
        <router-link to="/about-us" class="w-full sm:w-auto">
          <button class="text-white p-3 rounded bg-black w-fit px-4 py-2">
            Learn more
          </button>
        </router-link>
      </div>
    </div>

    <!--Third Initiative Section-->
    <div
      class="flex flex-col md:flex-row items-center justify-between px-4 py-6 gap-6"
    >
      <!-- Image -->
      <img
        src="../assets/images/foundation5.jpg"
        class="w-30 h-30 md:w-60 md:h-50 object-cover rounded-md"
      />
      <!-- Text and Button Section -->
      <div class="flex flex-col justify-center flex-1 text-center md:text-left">
        <strong class="text-3xl block">
          Educational Empowerment Program
        </strong>
        <p class="mt-2">
          To provide easy access to educational resources via Scholarship
          Programs, School Infrastructure Development, Digital Literacy
          Initiatives, and online Education.
        </p>
      </div>

      <!-- Button -->
      <div class="mt-4 lg:pt-10 md:mt-0">
        <router-link to="/about-us" class="w-full sm:w-auto">
          <button class="text-white p-3 rounded bg-black w-fit px-4 py-2">
            Learn more
          </button>
        </router-link>
      </div>
    </div>
  </div>

    <!-- Latest News Updates Section -->
    <section class="bg-gray-50 py-10 w-full">
      <div class="max-w-7xl mx-auto px-4 text-center">
        <div class="max-w-2xl mx-auto mb-10">
          <h2 class="text-3xl md:text-4xl font-bold mb-3 text-black">
            Latest <span class="text-blue-500">News</span> Updates
          </h2>
          <p class="text-gray-600">
            Stay informed with the latest announcements, educational insights,
            and important updates from our school.
          </p>
        </div>

        <!-- News Slider -->
        <div class="relative">
          <div class="overflow-hidden">
            <div
              class="flex transition-transform duration-500 ease-in-out"
              :style="{
                transform: `translateX(-${
                  currentNewsIndex * (100 / slidesToShow)
                }%)`,
              }"
            >
              <div
                v-for="(card, index) in cards"
                :key="index"
                class="px-4 mb-5 flex-shrink-0"
                :style="{ width: `${100 / slidesToShow}%` }"
              >
                <div
                  class="bg-white h-full rounded-xl shadow-md overflow-hidden hover:shadow-lg flex flex-col"
                >
                  <img
                    :src="card.image"
                    :alt="card.title"
                    class="w-full h-44 object-cover"
                  />
                  <div class="p-4 text-left flex flex-col flex-grow">
                    <h3 class="font-semibold text-sm mb-2 text-gray-800">
                      {{ card.title }}
                    </h3>
                    <div
                      class="flex items-center text-gray-500 text-sm mb-4 space-x-4"
                    >
                      <span
                        ><i class="far fa-calendar-alt mr-1 text-green-600"></i
                        >{{ card.date }}</span
                      >
                      <span
                        ><i class="fas fa-tag mr-1 text-yellow-600"></i
                        >{{ card.category }}</span
                      >
                    </div>
                    <a
                      href="#"
                      class="text-blue-600 font-medium text-sm hover:underline mt-auto"
                      >Read More →</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Navigation -->
          <button
            @click="prevNewsSlide"
            :disabled="currentNewsIndex === 0"
            class="absolute left-0 top-1/2 -translate-y-1/2 w-10 h-10 bg-white shadow rounded-full text-gray-700 hover:bg-gray-100 disabled:opacity-30"
          >
            ‹
          </button>
          <button
            @click="nextNewsSlide"
            :disabled="currentNewsIndex >= maxNewsIndex"
            class="absolute right-0 top-1/2 -translate-y-1/2 w-10 h-10 bg-white shadow rounded-full text-gray-700 hover:bg-gray-100 disabled:opacity-30"
          >
            ›
          </button>
        </div>

        <!-- Indicators -->
        <div class="flex justify-center mt-6 space-x-2">
          <button
            v-for="index in 4"
    :key="index"
    @click="goToNewsSlide(index - 1)"
    class="w-3 h-3 rounded-full"
    :class="(index - 1) === currentNewsIndex ? 'bg-blue-500' : 'bg-gray-300'"
  ></button>
        </div>
      </div>
    </section>

    <!-- Do You Know Section -->
    <section class="bg-gray-50 py-20 w-full">
      <div class="my-10 px-4">
        <div class="relative overflow-hidden">
          <div
            class="flex transition-transform duration-700 ease-in-out"
            :style="{ transform: `translateX(-${currentIndex * 100}%)` }"
          >
            <div
              v-for="(slide, index) in slides"
              :key="index"
              class="w-full flex-shrink-0 px-2"
            >
              <div
                :class="[
                  slide.bg,
                  'rounded-sm text-white shadow-lg p-6 h-[350px] flex flex-col justify-center items-center text-center',
                ]"
              >
                <h2 class="text-3xl font-bold uppercase mb-3">
                  {{ slide.title }}
                </h2>
                <p class="mb-4 text-sm">{{ slide.description }}</p>
                <button
                  class="px-6 py-2 bg-white text-black rounded hover:bg-black hover:text-white transition"
                >
                  {{ slide.button }}
                </button>
              </div>
            </div>
          </div>

          <!-- Arrows -->
          <button
            @click="prevSlide"
            class="absolute top-1/2 -left-4 transform -translate-y-1/2 bg-white text-black rounded-full w-10 h-10 flex items-center justify-center shadow-md hover:bg-gray-200"
          >
            ‹
          </button>
          <button
            @click="nextSlide"
            class="absolute top-1/2 -right-4 transform -translate-y-1/2 bg-white text-black rounded-full w-10 h-10 flex items-center justify-center shadow-md hover:bg-gray-200"
          >
            ›
          </button>

          <!-- Dots -->
          <div class="mt-6 flex justify-center space-x-2">
            <button
              v-for="(_, index) in slides"
              :key="index"
              @click="goToSlide(index)"
              class="w-3 h-3 rounded-full"
              :class="currentIndex === index ? 'bg-gray-300' : 'bg-gray-400'"
            ></button>
          </div>
        </div>
      </div>
    </section>
  </template>

  <script setup>
    import { ref, onMounted, onBeforeUnmount } from "vue";

    // News Slider 
    const cards = ref([
      {
        image: require ("../assets/images/foundation2.jpg"),
        title: "New Scholarship Program Launched",
        date: "July 15, 2025",
        category: "Scholarship",
      },
      {
        image: require ("../assets/images/foundation7.jpg"),
        title: "Science Fair Winners Announced",
        date: "July 10, 2025",
        category: "Events",
      },
      {
        image: require ( "../assets/images/foundation1.jpg"),
        title: "Coding Bootcamp for Teens Kicks Off",
        date: "July 5, 2025",
        category: "Training",
      },
      {
        image: require ("../assets/images/foundation8.jpg"),
        title: "Community Outreach in Kabusa Village",
        date: "July 1, 2025",
        category: "Outreach",
      },
       {
        image: require ("../assets/images/foundation2.jpg"),
        title: "New Scholarship Program Launched",
        date: "July 15, 2025",
        category: "Scholarship",
      },
      {
        image: require ("../assets/images/foundation7.jpg"),
        title: "Science Fair Winners Announced",
        date: "July 10, 2025",
        category: "Events",
      },
      {
        image: require ( "../assets/images/foundation1.jpg"),
        title: "Coding Bootcamp for Teens Kicks Off",
        date: "July 5, 2025",
        category: "Training",
      },
      {
        image: require ("../assets/images/foundation8.jpg"),
        title: "Community Outreach in Kabusa Village",
        date: "July 1, 2025",
        category: "Outreach",
      },
       {
        image: require ("../assets/images/foundation2.jpg"),
        title: "New Scholarship Program Launched",
        date: "July 15, 2025",
        category: "Scholarship",
      },
      {
        image: require ("../assets/images/foundation7.jpg"),
        title: "Science Fair Winners Announced",
        date: "July 10, 2025",
        category: "Events",
      },
      {
        image: require ( "../assets/images/foundation1.jpg"),
        title: "Coding Bootcamp for Teens Kicks Off",
        date: "July 5, 2025",
        category: "Training",
      },
      {
        image: require ("../assets/images/foundation8.jpg"),
        title: "Community Outreach in Kabusa Village",
        date: "July 1, 2025",
        category: "Outreach",
      },
      // {
      //   image: require ("../assets/images/children.jpg"),
      //   title: "Community Outreach in Kabusa Village",
      //   date: "July 1, 2025",
      //   category: "Outreach",
      // },
      // {
      //   image: require ("../assets/images/children.jpg"),
      //   title: "Community Outreach in Yola",
      //   date: "Oct 1, 2025",
      //   category: "Outreach",
      // },
      // {
      //   image: require ("../assets/images/children.jpg"),
      //   title: "Community Outreach in Kabusa Village",
      //   date: "July 1, 2025",
      //   category: "Outreach",
      // },
      // {
      //   image: require ("../assets/images/children.jpg"),
      //   title: "Community Outreach in Kabusa Village",
      //   date: "July 1, 2025",
      //   category: "Outreach",
      // }, 
    ]);

    const currentNewsIndex = ref(0);
    const slidesToShow = 4; 
    const maxNewsIndex = ref(cards.value.length - slidesToShow);

    function nextNewsSlide() {
      if (currentNewsIndex.value < maxNewsIndex.value) {
        currentNewsIndex.value += 1;
      }
    }
    function prevNewsSlide() {
      if (currentNewsIndex.value > 0) {
        currentNewsIndex.value -= 1;
      }
    }
    function goToNewsSlide(index) {
      currentNewsIndex.value = index;
    }

    // Do You Know Section 
    const slides = ref([
      {
        title: "Pitch Your Dream",
        description:
          "Helping Nigerian Youths turn ideas into funded enterprises.",
        button: "Learn More",
        bg: "bg-orange-600",
      },
      {
        title: "Support Orphanages",
        description:
          "Providing food, supplies, and education to underprivileged children.",
        button: "See Impact",
        bg: "bg-blue-800",
      },
      {
        title: "Educational Empowerment",
        description:
          "Scholarships, infrastructure, and digital literacy programs.",
        button: "Explore",
        bg: "bg-green-700",
      },
      {
        title: "Health Outreach",
        description:
          "Offering health & wellness services in underserved areas.",
        button: "Join Us",
        bg: "bg-purple-700",
      },
    ]);

    const currentIndex = ref(0);
    let autoplayInterval = null;

    function nextSlide() {
      currentIndex.value = (currentIndex.value + 1) % slides.value.length;
    }
    function prevSlide() {
      currentIndex.value =
        currentIndex.value === 0
          ? slides.value.length - 1
          : currentIndex.value - 1;
    }
    function goToSlide(index) {
      currentIndex.value = index;
    }
    function startAutoplay() {
      autoplayInterval = setInterval(nextSlide, 5000);
    }
    function stopAutoplay() {
      clearInterval(autoplayInterval);
    }

    onMounted(() => {
      startAutoplay();
    });
    onBeforeUnmount(() => {
      stopAutoplay();
    });
  </script>

  <style scoped>
    .swiper-pagination-bullet {
      background: #f37021;
      opacity: 0.7;
    }
    .swiper-pagination-bullet-active {
      background: #f37021;
      opacity: 1;
    }
</style>
